// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonE_container__3oBBe","title":"ButtonE_title__3kbHc","rightIcon":"ButtonE_rightIcon__1Jwr9","leftIcon":"ButtonE_leftIcon__3CkPn"};